import { Building2, PartyPopper, Plane, Recycle, Sprout } from "lucide-react";

import { TScenario } from "@/types";

const ScenarioIcons = {
  [TScenario.simplifiedLca]: Recycle,
  [TScenario.employeesHabits]: Building2,
  [TScenario.events]: PartyPopper,
  [TScenario.travels]: Plane,
  [TScenario.free]: Sprout,
};

export { ScenarioIcons };
